import {
  Component,
  AfterViewInit,
  EventEmitter,
  OnDestroy,
  Input,
  Output, OnInit
} from '@angular/core';

import 'tinymce';
import 'tinymce/themes/modern';

import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
declare var tinymce: any;

@Component({
  selector: 'app-tiny-editor',
  template: '<textarea id="{{elementId}}">{{ text }}</textarea>'
})
export class TinyEditorComponent implements AfterViewInit, OnDestroy {
  @Input() elementId: string;
  @Input() text: string;
  @Output() onEditorContentChange = new EventEmitter();
  editor;

  ngAfterViewInit() {
    tinymce.init({
      selector: '#' + this.elementId,
      branding: false,
      resize: false,
      plugins: ['link', 'table'],
      skin_url: 'assets/skins/lightgray',
      menubar: 'false',
      toolbar: 'bold italic',
      setup: editor => {
        this.editor = editor;
        editor.on('keyup change', () => {
          const content = editor.getContent();
          this.onEditorContentChange.emit(content);
        });
      }
    });
  }


  ngOnDestroy() {
    tinymce.remove(this.editor);
  }

}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/shared/tinyeditor/tinyeditor.ts